import apiClient from "../apiClient";
import { AllInquiries, CreateInquiry } from "./types.api";

export const getInquiries = async (params: AllInquiries) => {
  const response = await apiClient.get("inquiries/getAll", { params });
  return response.data;
};

export const createInquiry = async (params: CreateInquiry) => {
  await apiClient.post("inquiries/createInquiry", params);
};
